import { AxiosRequestConfig } from 'axios';

import { apiSensedia } from '../api-sensedia';

type DataQuery = {
  cpf?: string;
  nome?: string;
  status?: string;
  data_solicitacao?: number;
  data_efetivacao?: number;
};

export const getData = async (
  page = 0,
  {
    cpf = '',
    nome = '',
    status = '',
    data_solicitacao = undefined,
    data_efetivacao = undefined
  }: DataQuery = {}
) => {
  const params = {
    page: String(page),
    cpf,
    nome,
    status,
    data_solicitacao,
    data_efetivacao
  };
  const axiosConfig: AxiosRequestConfig = {
    params: { ...params },
    timeout: 6000
  };
  const requestUrl = `/gestao-de-carteiras/solicitacoes-sos-prev`;

  const response = await apiSensedia.get(requestUrl, axiosConfig);

  return response.data.data;
};

export const getTotalCountRegisters = async () => {
  const requestUrl = `/gestao-de-carteiras/solicitacoes-sos-prev/count`;

  const response = await apiSensedia.get(requestUrl, { timeout: 6000 });

  return response.data.data;
};

export const getTotalSum = async () => {
  const requestUrl = `/gestao-de-carteiras/solicitacoes-sos-prev/total`;

  const response = await apiSensedia.get(requestUrl, { timeout: 6000 });

  return response.data.data;
};
